import RCSwitch, { SwitchChangeEventHandler } from 'rc-switch';

import './style/switch.less';

type PropsT = {
  id: string;
  checked: boolean;
  onChange: SwitchChangeEventHandler | null;
  onBlur?: (e: any) => void;
  onFocus?: (e: any) => void;
  className: string;
  hidden: boolean;
  disabled: boolean;
  labelA: string;
  value?: any;
  labelB: string;
};
const Switch = ({
  id,
  checked,
  onChange,
  className,
  disabled,
  labelA,
  labelB,
}: PropsT) => {
  let labelAClass;
  let labelBClass;
  const hiddenRender = '';
  const defaultStyleRender = '';

  if (checked === true) {
    labelAClass = 'labelA';
    labelBClass = 'labelB active';
  } else {
    labelAClass = 'labelA active';
    labelBClass = 'labelB';
  }

  return (
    <span
      className={
        'dixa-switch noselect ' + hiddenRender + defaultStyleRender + className
      }
    >
      <label className={labelAClass}>{labelA}</label>
      <RCSwitch
        disabled={disabled}
        id={id}
        onChange={
          typeof onChange === 'function'
            ? onChange
            : () => {
                /** Noop. */
              }
        }
        checked={checked}
      />
      <label className={labelBClass}>{labelB}</label>
    </span>
  );
};

Switch.defaultProps = {
  id: '',
  checked: false,
  labelA: '',
  labelB: '',
  className: '',
  onChange: function () {
    /** Noop. */
  },
  disabled: false,
  hidden: false,
  invisibleOnDisabled: false,
};

export default Switch;
